import React, {useState} from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import "./index.css";
import assets from "../../../util/assets";
import ChatWindowSmileyDropdown from "../chat-window-smiley-dropdown";
import PropTypes from "prop-types";

ChatWindowAttachmentInputToolbar.propTypes = {
    setText: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
};

function ChatWindowAttachmentInputToolbar(props) {

    const [text, setText] = useState('');

    const onChangeText = (text) => {
        setText(text)
        props.setText(text);
    }

    const onKeyDown = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            props.onSend();
            e.preventDefault();
        }
        return false;
    }

    const _onSend = () => {
        if (text.trim().length > 0) {
            const {onSend} = props;
            onSend({text: text.trim()}, true);
            setText('')
        }
    }

    const setChosenEmoji = (emojiObject) => {
        console.log("setChosenEmoji",emojiObject)
        setText(`${text} ${emojiObject.native} `)
    }

    return (
        <div className="display-flex-align-center chat-window-attachment-input-toolbar">
            <TextareaAutosize
                className="textarea"
                onKeyDown={e => onKeyDown(e)}
                placeholder={"Type a message"}
                onChange={event => onChangeText(event.target.value)}
                value={text}
            />
            <div className="display-flex">
                {
                    text.length > 0 &&
                    <img src={assets.messaging.preview.grey_cross}
                         alt="cross icon"
                         className="cursor-pointer padding-16"
                         onClick={() => {
                             setText('')
                         }}
                    />
                }
                <ChatWindowSmileyDropdown setChosenEmoji={setChosenEmoji}/>
            </div>
        </div>
    );
}

export default ChatWindowAttachmentInputToolbar;